module.exports = __webpack_public_path__ + "static/img/human__icon.49da6b4e.svg";